import React, { useState, createContext, useContext, ReactNode } from 'react';

const MainContext = createContext();
function MainProvider({ children }) {
    const [lstUserDetail, setLstUserDetail] = useState([]);
    return (
        <MainContext.Provider value={{
            lstUserDetail,
            setLstUserDetail
        }}>
            {children}
        </MainContext.Provider>
    );
}
export const MainState = () => {
    return useContext(MainContext);
};
export default MainProvider;
